import { DbHelper } from "@app/shared/model/db-object.model";
import { ImportMap } from "@app/shared/resources/class-importer-exporter.service";

export interface CustomerServicePlan {
    id?: number;
    projectId?: number;
    planName?: string;
    planRate?: number;
    planStartDate?: string;
    planEndDate?: string;
    currency?: string;
}

/* eslint-disable @typescript-eslint/naming-convention */
export interface CustomerServicePlanData {
    id?: number;
    project_id?: number;
    plan_name?: string;
    plan_rate?: number;
    plan_start_date?: string;
    plan_end_date?: string;
    currency?: string;
}
/* eslint-enable @typescript-eslint/naming-convention */

export class CustomerServicePlan extends DbHelper<CustomerServicePlan, CustomerServicePlanData> {
    static dbTypeName = "Customer_Service Plan";

    static readonly importMap: ImportMap<CustomerServicePlan, CustomerServicePlanData> = [
        { i: "id", o: "id" },
        { i: "project_id", o: "projectId" },
        { i: "plan_name", o: "planName" },
        { i: "plan_rate", o: "planRate" },
        { i: "plan_start_date", o: "planStartDate" },
        { i: "plan_end_date", o: "planEndDate" },
        { i: "currency", o: "currency" },
    ];

    static fromDbObject(customerServicePlan): CustomerServicePlan {
        return new CustomerServicePlan(
            customerServicePlan[CustomerServicePlan.importMap[0].i],
            customerServicePlan[CustomerServicePlan.importMap[1].i],
            customerServicePlan[CustomerServicePlan.importMap[2].i],
            customerServicePlan[CustomerServicePlan.importMap[3].i],
            customerServicePlan[CustomerServicePlan.importMap[4].i],
            customerServicePlan[CustomerServicePlan.importMap[5].i],
            customerServicePlan[CustomerServicePlan.importMap[6].i]
        );
    }

    constructor(
        public id?: number,
        public projectId?: number,
        public planName?: string,
        public planRate?: number,
        public planStartDate?: string,
        public planEndDate?: string,
        public currency?: string
    ) {
        super();
    }
}
